import { useEffect } from "preact/hooks";
import { LocationProvider, Router, Route } from "preact-iso";
import { idx, toast } from "./store";
import { loadIndex, loadDescriptions } from "./lib/data";
import { initSearch } from "./lib/search";
import { Home } from "./routes/Home";
import { CoursePage } from "./routes/CoursePage";
import { TeacherPage } from "./routes/TeacherPage";
import { RoomPage, RoomsPage } from "./routes/Rooms";
import { UnitPage, UnitsPage } from "./routes/Units";
import { SharedPage } from "./routes/SharedPage";
import { About } from "./routes/About";
import { Today } from "./routes/Today";
import { Footer } from "./components/Footer";

export function App() {
  useEffect(() => {
    loadIndex().then(async (i) => {
      idx.value = i;
      await loadDescriptions(i);
      idx.value = { ...i };
      initSearch(i);
    });
  }, []);
  return (
    <LocationProvider>
      {idx.value ? (
        <Router>
          <Route path="/" component={Home} />
          <Route path="/c/:id" component={CoursePage} />
          <Route path="/t/:tid" component={TeacherPage} />
          <Route path="/r/:fac/:room" component={RoomPage} />
          <Route path="/rooms" component={RoomsPage} />
          <Route path="/u" component={UnitsPage} />
          <Route path="/u/:code" component={UnitPage} />
          <Route path="/s/:id" component={SharedPage} />
          <Route path="/about" component={About} />
          <Route path="/danas" component={Today} />
          <Route default component={Home} />
        </Router>
      ) : (
        <div class="loading">Učitavam raspored…</div>
      )}
      {idx.value && <Footer />}
      {toast.value && <div class="toast">{toast.value}</div>}
    </LocationProvider>
  );
}
